import { Link } from 'react-router-dom'

type Props = {
  /** Background behind the logo */
  tone?: 'dark' | 'light'
  /** full = mark + wordmark (or lockup image on dark). mark = P only */
  variant?: 'full' | 'mark'
  className?: string
  /** Internal SPA route */
  to?: string
  /** External / absolute link */
  href?: string
  title?: string
}

const MARK = '/brand/perfect-predict-mark.png'

/**
 * Perfect Predict brand mark (P + target + BUY/SELL arrows) + wordmark.
 * Use tone="dark" on dark sidebars (white text); tone="light" on light surfaces.
 */
export function BrandLogo({
  tone = 'dark',
  variant = 'full',
  className = '',
  to,
  href,
  title = 'Perfect Predict',
}: Props) {
  const cls = `pp-logo pp-logo--${tone} pp-logo--${variant}${className ? ` ${className}` : ''}`

  // Panels/sidebars: compact mark + wordmark (full lockup PNG is too large / padded).
  const inner =
    variant === 'mark' ? (
      <img className="pp-logo__mark" src={MARK} alt="" width={36} height={36} />
    ) : (
      <>
        <img className="pp-logo__mark" src={MARK} alt="" width={36} height={36} />
        <span className="pp-logo__text">{title}</span>
      </>
    )

  if (to) {
    return (
      <Link className={cls} to={to} aria-label={title}>
        {inner}
      </Link>
    )
  }

  if (href) {
    return (
      <a className={cls} href={href} aria-label={title}>
        {inner}
      </a>
    )
  }

  return (
    <div className={cls} aria-label={title}>
      {inner}
    </div>
  )
}
